exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layer-rectangle-wrapper[data-v-f5567644]{position:absolute;top:0;left:0;width:100%;height:0;padding-bottom:100%}@media (max-width:990px){.layer-rectangle-wrapper[data-v-f5567644]{position:static}}.layer[data-v-f5567644]{position:absolute;width:100%;height:100%}.layer-2[data-v-f5567644]{top:9%;left:9%;width:82%;height:82%}.layer-3[data-v-f5567644]{top:17%;left:17%;width:66%;height:66%}.layer-3 svg[data-v-f5567644]{width:100%;height:100%;pointer-events:none}.view[data-v-f5567644]{position:absolute;top:.5%;left:.5%;width:99%;height:99%;border-radius:50%;overflow:hidden}.view.visible-overflow[data-v-f5567644]{overflow:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f5567644","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SlideFragment/slideComponents/CircleWrapper.vue
// module id = 111
// module chunks = 0